import { ref } from 'vue'
import type { Ref } from 'vue'
import { Reply } from '@/types/message'
import { getMessageForReply } from '@/store/messages'

export const defaultReply: Reply = {
  content: {
    message: '',
    type: 'audio'
  },
  message_id: '',
  type: ''
}

const reply: Ref<Reply> = ref(defaultReply)

export function setReply (payload: Reply): void {
  reply.value = payload
}

export function getReply (): Reply {
  return reply.value
}

export function clearReply (): void {
  reply.value = defaultReply
}

export function searchMessageOnReply (id: string): boolean {
  const message = getMessageForReply(id)
  if (message) {
    setReply({
      type: message.type,
      message_id: message.message_id,
      content: message.content
    })
    return true
  }
  return false
}

export default reply.value
